// ЗАГОТОВКА слоя локализации.
//
// Пока это словарь и функция перевода без реактивности: интерфейс v1 русский,
// переключателя языка в продукте нет. Полноценный провайдер локали приедет вместе
// с I18nProvider из @restomarker/ui-kit — важно, чтобы app и ui-kit жили в одной
// локали, а не в двух независимых (app.md §4, ui-kit.md §6).

import { en } from './en';
import { ru, type MessageKey } from './ru';

export type Locale = 'ru' | 'en';

export const DEFAULT_LOCALE: Locale = 'ru';

const dictionaries: Record<Locale, Partial<Record<MessageKey, string>>> = { ru, en };

/** Перевод по ключу. Недостающий перевод падает обратно на русский, а не на пустую строку. */
export function t(key: MessageKey, locale: Locale = DEFAULT_LOCALE): string {
  return dictionaries[locale][key] ?? ru[key];
}

export { ru, en };
export type { MessageKey };
